<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
    
      <!-- <div v-if="ticketDetails" class="ST_details_head">
        <h4 class="ticket_title d-flex align-items-center">{{ticketDetails.customId}}

          <button
              v-if="activeUserInfo.roleId == 1"
              class="secondary_btn edit_btn"
              @click="openAssignPopup"
            >Manage bug assignments
          </button>
        </h4> 
          <p v-html="ticketDetails.description">{{ticketDetails.description}}</p>

          <h6 v-if="ticketDetails.createdByDetails">Created by <span>{{ticketDetails.createdByDetails.name}}</span> On   {{ticketDetails.createdOn | formatDate}}
          &nbsp;&nbsp; 
          
          </h6>
          <ul>
            <li v-if="ticketDetails.statusDetails">
              <label>Status</label>
              <span class="td_status" :class="{'new':ticketDetails.statusId==1 , 'inprogress':ticketDetails.statusId==2 , 'closed':ticketDetails.statusId== 3 , 'rejected':ticketDetails.statusId==4, 'defered':ticketDetails.statusId==5}"
              >{{ticketDetails['statusDetails']['name']}}
            </span> 
            </li>
            <li v-if="ticketDetails.projectDetails">
              <label>Project</label>
              <span>{{ticketDetails.projectDetails.name}}</span>
            </li>
            <li v-if="ticketDetails.productDetails">
              <label>Product</label>
              <span>{{ticketDetails.productDetails.name}}</span>
            </li>
            <li v-if="ticketDetails.assignEmpDetails && ticketDetails.assignEmpDetails.length > 0 && activeUserInfo.roleId == 1">
              <label>Assigned To</label>
                <ul class="assigned_list">
                   <li v-for="(other, indx) in ticketDetails.assignEmpDetails" :key="indx">
                     {{other.name}}
                    </li>
                </ul>
            </li>

            <li v-if="commentList && commentList.length > 0">
              <label>Updated On</label>
              <span>{{commentList[0].createdOn | formatDateTime}}</span>
            </li>

             <li v-if="ticketDetails.documents && ticketDetails.documents.length>0">
              <label>Attachments</label>
              <ul class="uploads_view padt0"> <li><vs-chip name="'fileSelected'" 
             v-for="(other, indx) in ticketDetails.documents" :key="indx"> {{ other.name }} 
             <span @click="download_file(other)" class="material-icons download">get_app</span>
             
             </vs-chip></li></ul>
            </li>

          </ul>          
      </div> -->

      <div class="page_header_wrap">
    <div class="page_header">
          <div>
            <h2 >Support Case Details</h2>
          </div>
          </div>
    </div> 

      <div v-if="ticketDetails" class="ST_details_head new">
        <div class="ST_title">
          <h4 class="ticket_title d-flex align-items-center">{{ticketDetails.customId}}
              <span v-if="ticketDetails.statusDetails" class="st_status" :class="{'new':ticketDetails.statusId==1 , 'inprogress':ticketDetails.statusId==2 , 'closed':ticketDetails.statusId== 3 , 'rejected':ticketDetails.statusId==4, 'defered':ticketDetails.statusId==5,'resloved':ticketDetails.statusId==6,'reopen':ticketDetails.statusId==7}"
              >{{ticketDetails['statusDetails']['name']}}
            </span>
          </h4>

         <div class="ST_title_right">
       
               <multiselect  v-if="activeUserInfo.roleId == 1 || ( ( ticketDetails.assignedTo
             && ticketDetails.assignedTo.indexOf(activeUserInfo.userId) > -1 ) || ( ticketDetails.statusId== 3 && ticketDetails.owners && ticketDetails.owners.indexOf(activeUserInfo.userId) > -1 ))"
                v-model="statusId"
                :options="status_list"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="false"
                :preserve-search="true"
                placeholder="Select "
                label="name"
                track-by="name"
                :preselect-first="true"
                id="status"
                @input="openUpdateStatus()"
                :multiple="false"
                >
          </multiselect>
             <button
              v-if="activeUserInfo.roleId == 1"
              class="primary_btn"
              @click="openAssignPopup"
            >Manage Case assignments
          </button>
            </div>
          
        </div>
         <p v-if="checkProperty(ticketDetails ,'title' )">
              <label>Subject </label>
              <span> : {{checkProperty(ticketDetails ,'title')}}</span>
            </p>
        
        <p v-html="ticketDetails.description">{{ticketDetails.description}}</p>
        <div class="ST_creation_details">
          <label v-if="ticketDetails.createdByDetails">
          <template v-if=" activeUserInfo.roleId !=2  || (activeUserInfo.roleId == 2 && ticketDetails['createdBy']==userdata.userId)">
            Created by
          </template>
          <template v-else>  Created & Shared by</template>
          
          <span>{{ticketDetails.createdByDetails.name}}</span>On <span>{{ticketDetails.createdOn | formatDate}}</span>.</label>
          
          <label v-if="commentList && commentList.length > 0">Last Updated On<span>{{commentList[0].createdOn | formatDateTime}}</span></label>               
        </div>
          
        
        <!-- <button  @click="openUpdate()" class="td_edit"><img src="@/assets/images/pages/edit.png">Edit</button> -->
          <!--<h5>Needs additional citations for verification</h5>-->
          

          
          <ul>
           


            <li v-if="checkProperty(ticketDetails ,'jiraKey') !='--' && checkProperty(ticketDetails ,'jiraKey') !='' && activeUserInfo.roleId != 2">
              <label>jira Id</label>
              <span style="cursor:pointer" @click="goTojira(ticketDetails['jiraKey'])" >{{ticketDetails.jiraKey}}</span>
            </li>
            <li v-if="checkProperty(ticketDetails ,'priorityDetails' ,'name')">
              <label>Priority</label>
              <span>{{checkProperty(ticketDetails ,'priorityDetails' ,'name')}}</span>
            </li>

            <li v-if="checkProperty(ticketDetails ,'typeDetails' ,'name')">
              <label>Case Type</label>
              <span>{{checkProperty(ticketDetails ,'typeDetails' ,'name')}}</span>
            </li>
            
            <li v-if="checkProperty(ticketDetails ,'deviceFamilyDetails' ,'name')">
              <label>Device Family</label>
              <span>{{checkProperty(ticketDetails ,'deviceFamilyDetails' ,'name')}}</span>
            </li>
            <li v-if="checkProperty(ticketDetails ,'versionDetails' ,'version')">
              <label>Version</label>
              <span>{{checkProperty(ticketDetails ,'versionDetails' ,'version')}}</span>
            </li>
            
            <li v-if="checkProperty(ticketDetails ,'areaDetails' ,'name')">
              <label>Area</label>
              <span>{{checkProperty(ticketDetails ,'areaDetails' ,'name')}}</span>
            </li>


            <li v-if="ticketDetails.projectDetails">
              <label>Project</label>
              <span>{{ticketDetails.projectDetails.name}}</span>
            </li>

            <li v-if="ticketDetails.productDetails">
              <label>Product</label>
              <span>{{ticketDetails.productDetails.name}}</span>
            </li>
            <li v-if="ticketDetails.assignEmpDetails && ticketDetails.assignEmpDetails.length > 0 && activeUserInfo.roleId == 1">
              <label>Assigned To</label>
                <ul class="assigned_list">
                   <li v-for="(other, indx) in ticketDetails.assignEmpDetails" :key="indx">
                     {{other.name}}
                    </li>
                </ul>
            </li>

            <li v-if="((activeUserInfo.roleId == 2 && ticketDetails['createdBy']==userdata.userId) && checkProperty(ticketDetails ,'sharedToDetails') && ticketDetails['sharedToDetails'].length>0)">
            <label>Shared With</label>
            <ul class="td_addigned_list"> 
                  <template v-if="checkProperty(ticketDetails ,'sharedToDetails')">
                    <template v-for="(item1, ind) in ticketDetails.sharedToDetails">
                    <li :key="ind" v-if="ind < 10" >
                      <div class="td_addigned_name">
                        <span>{{ item1.name | getTwolatters }}</span>
                        <label>{{ item1.name }}</label>
                      </div>

                      
                    </li>
                
                    </template>
                  </template>  
                  <li v-if=" checkProperty(ticketDetails ,'sharedToDetails') &&  ticketDetails.sharedToDetails.length > 10">
                    
                    <vs-dropdown vs-trigger-click class="syam">
                      <template v-if="ticketDetails.sharedToDetails.length > 10">
                          <a class="a-icon more" href.prevent> 
                      <span>{{ ticketDetails.sharedToDetails.length - 10 }}+</span>
                    </a>               
                    </template>               
                    <vs-dropdown-menu>
                      <vs-dropdown-item  v-if="ticketDetails.sharedToDetails.length > 10">
                        <template v-for="(item1, ind) in ticketDetails.sharedToDetails">
                              <span class="list_item padtb5" v-if="ind >= 10" :key="ind">{{ item1.name }}</span>
                                                          
                                </template>
                    
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                    
                  </li>
                </ul>
            </li>

             <li v-if="ticketDetails.documents && ticketDetails.documents.length>0" class="uploads_view_wrap">
              <label>Attachments</label>
              <ul class="uploads_view padt0">
                <li>
                  <vs-chip name="'fileSelected'"  
                    v-for="(other, indx) in ticketDetails.documents" :key="indx"> {{ other.name }} 
                    <span @click="download_file(other)" class="material-icons download">get_app</span>
                  </vs-chip>
                </li>
              </ul>
            </li>

          </ul>          
      </div>
      <!-- <button
        v-if="activeUserInfo.roleId == 1"
        class="secondary_btn edit_btn"
        @click="openAssignPopup"
      >
        Assign Employees
      </button> -->

      <div class="expanded_details ticket_comments">
        <div class="write_post">
          <!--<vs-textarea v-model="comment.comment" placeholder="Write post here" /> -->

 <ckeditor v-validate="'required'" name="CommentSection" :editor="editor"  :config="{}" v-model="comment.comment"  ></ckeditor>

          <div @click="documents=[]" class="uploads">
             <div @click="documents=[]" class="files_wrap">
                    <file-upload v-model="documents" class="file-upload-input"
                    accept=""  :name="'filescomment'" data-vv-as="Upload SDK files"
                      :multiple="true" @input="upload(documents, 'comment')" >
                      <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                    </file-upload>
                    <span class="text-danger text-sm"
            v-show="errors.has('files')">{{ errors.first('files') }}</span>
            </div>
            <ul v-if="comment.documents && comment.documents.length > 0" class="uploaded-list support_uploaded-list">
             
             <li><vs-chip @click="remove(indx, 'comment')" name="'fileRemelected'" 
              v-for="(other, indx) in comment.documents" :key="indx"  closable     > {{ other.name }}
              <!-- <span @click="download_file(other)" class="material-icons download">get_app</span>-->
              </vs-chip></li>
              </ul>
             
            <div class="upload_actions">
               <!--<multiselect  v-if="activeUserInfo.roleId == 1 || (ticketDetails.assignedTo
             && ticketDetails.assignedTo.indexOf(activeUserInfo.userId) > -1 && activeUserInfo.roleId != 2)"
                v-model="statusId"
                :options="status_list"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="false"
                :preserve-search="true"
                placeholder="Select "
                label="name"
                track-by="name"
                :preselect-first="true"
                id="status"
                @input="openUpdateStatus()"
                :multiple="false"
                >
          </multiselect>-->
              <button :disabled="!comment.comment || getAactiveCustomer!=null" class="primary_btn"  @click="onSubmit()">POST</button>
            </div>
          </div>
        </div>
        <div v-if="commentList && commentList.length > 0" class="comments_section">
          <!--<div class="comments_list">
              <figure><img src="@/assets/images/pages/user-icon.png"> </figure>
              <div class="comments_cnt">
                <h4>Antonette<span>15 min ago</span></h4>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              </div>
          </div>-->
          <div v-for="(item, index) in commentList" :key="index" class="comments_list">
              <figure><img src="@/assets/images/pages/user-icon.png"> </figure>
              <div class="comments_cnt">
                <!-- v-if="item.fromJira " -->
               <template>
               <!--v-if="item.fromJira && item.jiraAuthor && item.intStatusId<=1 && activeUserInfo.roleId==1 " -->
                <template v-if="item.fromJira && item.jiraAuthor && item.intStatusId<=1 && activeUserInfo.roleId==1 ">
                    <h4 v-if="item.jiraAuthor">{{item.jiraAuthor.displayName}}<span>Jira</span></h4>
                    <span>{{item.jiraAuthor.emailAddress}}</span>
               </template>
               <template v-else><h4 v-if="item.createdByDetails">{{item.createdByDetails.name}}<span v-if="activeUserInfo.roleId==1 && item.fromJira">Jira</span></h4></template>
               
               <p v-if="item.reslovedCommentAttachments" v-html="item.comment"></p>
                <p v-else v-html="checkAttachments( item.comment, item.documents ,item )"></p>
              <!-- <p v-else v-html="checkAttachments( item.comment+'[^sample.docx]', item.documents ,item )"></p>-->
                <div class="jira_autor">
                  <span>{{item.createdOn | formatDateTime}}</span>
                  
                  <!-- reslovedCommentAttachments <p v-if="item.fromJira && activeUserInfo.roleId==1" >Commented by<span>
                  
                  <template  v-if="checkProperty(item ,'jiraAuthor','displayName') !='--' && checkProperty(item ,'jiraAuthor','displayName') !=''" >
                      {{item.jiraAuthor['displayName']}} ( from Jira )
                  </template>
                  
                  
                  </span></p>-->
                </div>
                <div class="jira_actions" v-if="activeUserInfo.roleId==1" >
                    <button class="edit" v-if="item.intStatusId<=1"  @click="toggleEdit(item ,index)"  ><img src="@/assets/images/pages/edit.png">{{item['edit']?'Close Edit':'Edit'}}</button>               
                    <button class="primary_btn approve_btn"  @click="toggleEdit(item ,index ,false) ;jiracommentActionPopup =true" v-if="item.fromJira && item.intStatusId<=1"  >Approve</button>
                  </div>
                
                <div v-if="item['edit'] && item.intStatusId<=1 && activeUserInfo.roleId==1" >
                  <ckeditor :editor="editor" v-model="selectedItem.comment" :config="editorConfig"></ckeditor>
                  <div class="jira_comments">
                    <div class="jira_upload">
                      <div @click="documents=[]" class="files_wrap">
                              <file-upload v-model="documents" class="file-upload-input"
                              accept=""  :name="'selectedItem'" data-vv-as="Upload SDK files"
                                :multiple="true" @input="upload(documents ,'selectedItem')" >
                                <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                              </file-upload>
                              <span class="text-danger text-sm"
                      v-show="errors.has('files')">{{ errors.first('files') }}</span>
                      </div>
                      <ul  class="uploaded-list">                      
                        <li><vs-chip @click="remove(indx ,'selectedItem')" :name="'fileRemoveSelected'" 
                        v-for="(other, indx) in selectedItem.documents" :key="indx"  closable> {{ other.name }} </vs-chip></li>                      
                      </ul>
                    </div>
                    <button :disabled="!validateForm"  @click="updateComment()"  class="primary_btn">Update</button>
                    
                  </div>
                </div>
               
               </template>
              <!-- <template v-else>
                <h4 v-if="item.createdByDetails">{{item.createdByDetails.name}}</h4>                
                <p v-html="item.comment">{{item.comment}}</p> 
                <div class="jira_autor">
                  <span>{{item.createdOn | formatDateTime}}</span> 
                </div>
                
               </template>-->

               

                <ul v-if="item.documents && item.documents.length > 0 && !item.edit" class="uploads_view"> 
                   <li   ><vs-chip name="'fileRemoveSelected'" 
             v-for="(other, indx) in item.documents" :key="indx"   > {{ other.name }} <span @click="download_file(other)" class="material-icons download">get_app</span></vs-chip></li>
                  <!--<li><img src="@/assets/images/pages/graphic-1.png"></li>
                  <li><img src="@/assets/images/pages/graphic-1.png"></li>
                  <li><img src="@/assets/images/pages/graphic-1.png"></li>
                  <li><img src="@/assets/images/pages/graphic-1.png"></li>-->
                </ul>
              </div>
          </div> 
        </div>
      </div>

      <vs-popup
        class="holamundo"
        :active.sync="updateStatusFlag"
        title="Update Status"
      >
        <div class="createticket_form alert_messages">
          <p>Do you want to continue changing the status?</p>
          <div class="form_actions">
            <span class=" primary_btn marr15"  @click="onUpdateStatus()"> Yes</span>
            <button class="close_popup secondary_btn"  @click="updateStatusFlag=false">
              No
            </button>
          </div>
        </div>
      </vs-popup>

       

       <vs-popup
        class="holamundo"
        :active.sync="popupAssignFlag"
        title="Manage case assignments"
      >
        <div class="createticket_form">
          <form>
          <ul>
            <li>
              <div class="form-group">
                <label class="form_label">Assign Employee</label>
                <multiselect
                  v-model="assignedTo" 
                  :options="employeeList"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false" 
                  :preserve-search="true"
                  placeholder="Select "
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  id="assign"
                  :multiple="false"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Employee(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Employees Found</span>
                </multiselect>
              </div>
            </li>
          </ul>
        </form>
          <div class="form_actions">
            <span></span>
            <!--- :disabled="!validateAssign"----->
            <button class="close_popup primary_btn" 
             
              @click="onAssignEmployee()">
              Update
            </button>
          </div>
        </div>
      </vs-popup>



      <!---JIRA COMMENT ACTION---->
     
    <vs-popup
      class="holamundo"
      :active.sync="jiracommentActionPopup"
      :title="'Approve'"
    >
      <div class="createticket_form alert_popup">
        
       
        <p>
          Are you sure want to Approve ?
        </p>
        <div class="form_actions">
          <span class="secondary_btn" @click="jiracommentActionPopup=false">No</span>
         
          <button class="close_popup primary_btn marl15" @click="updateComment(true)">
            Yes
          </button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Multiselect from 'vue-multiselect-inv'
import FileUpload from "vue-upload-component/src";

import moment from "moment";
import _ from "lodash";

import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use( CKEditor );
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: { 
    vSelect,
    DateRangePicker, 
    Multiselect,
    FileUpload
  },
  computed: {

    getAactiveCustomer() {
     
      if(_.has(this.$store.state.auth , 'ViewAsCustomer')){
         return this.$store.state.auth.ViewAsCustomer
      }else if(localStorage.getItem('ViewAsCustomer')){
        return  JSON.parse(localStorage.getItem('ViewAsCustomer'));
      }else{
        return null;
      }
     
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.selectedItem.comment !== "" && (this.selectedItem.commentId !=null && this.selectedItem.commentId !='')
        
      );
    },
    activeUserInfo () {
      return this.$store.state.auth.user
    },
    validateAssign() {
      //return this.assignedTo.length > 0
      return this.assignedTo != null
    },
  },
  data:() => ({
    userdata:null,
    ticketId: '',
    ticketDetails: {},
    status_list: [],
    statusId: '',
    commentList: [],
    documents: [],
    comment:{
      comment: "",
      documents: [],
      today: moment().format("YYYY-MM-DD")
    },
    updateStatusFlag: false,
    popupUpdateticket: false,
    currentStatusDetails: null,
    products: [],
    projects: [],
    reportTo_obj:'',
    assignedTo:null,// [],
    employeeList: [],
    popupAssignFlag: false,
     config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        }
      },
    reportinglist: [
      { label: 'Internal Project', value: 'internal' },
      { label: 'Customer Project', value: 'customer' } 
    ],
    textarea: '',
      
      
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    weekLabel: 'W',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDay: 0,

    searchQuery: '',

    ////////////
    //jiraStatusList:[{'_id':1 ,'name':'Pending'} ,{'_id':2 ,'name':'Appove'} ,{'_id':3 ,'name':'Reject'} ],
    jiraStatusList:[{'_id':2 ,'name':'Appove'} ,{'_id':3 ,'name':'Reject'} ],
    
    jiracommentActionPopup:false,
    jiraComment:{
      commentId:'',
      intStatusId:null,
      selectedintStatusId:null,
      comment:'',
      documents:[]
    },
    documents:[],
    editor: ClassicEditor,
    editorConfig: {
        // The configuration of the editor.
         toolbar: [ 'bold', 'italic', '|', 'undo','redo' ,"indent" ,"Outdent" ,'NumberedList', 'BulletedList', ],
         //removePlugins:'image',

       //removeButtons :'Copy,Cut,Paste,Undo,Redo,Print,Form,TextField,Textarea,Button,SelectAll,NumberedList,BulletedList,CreateDiv,Table,PasteText,PasteFromWord,Select,HiddenField'
       
        
    },
    selectedItem:{
      commentId:'',
      intStatusId:null,
      selectedintStatusId:null,
      comment:'',
      documents:[]
    }
     
  }),
  methods:{
   checkAttachments(comment='' ,atta=[] ,item){

     this.$store.dispatch("getjiraAccountDetails", {"jiraAccountId":"60842781a41c7a00789e4531"});

     let attachments =_.cloneDeep(atta);
    //ticketDetails.documents
    if(this.ticketDetails.documents.length>0){
      _.forEach(this.ticketDetails.documents ,(fl)=>{
        attachments.push(_.cloneDeep(fl));

      });

    }
    
      
      if(attachments.length>0){
         
        // alert(JSON.stringify(attachments))
         
          _.forEach(attachments ,(attachment ,indx)=>{

            if(comment.includes(attachment.name)){
              
              
            // comment =  comment.replace('[^', '<h href="">', 1);
             //comment = comment.replace(']', '<span class="material-icons download">get_app</span>', 1);
           //  comment = comment.replace(']', '', 1);

                if(_.has(attachment , "path")){
                  attachment['url'] = attachment['path'];
                }
                let postdata = { keyName: attachment.url };

                this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                let href = response.data.result.data;
                let replaceString = "<a href='"+href+"' target='_blank'> "+attachment.name+" </a>";
                
              //  if(item.comment.include("[^"+attachment.name+"]")){
                
              //     item.comment =  item.comment.replace('[^'+attachment.name+']',replaceString, 1);
              //   }
                
                item.comment =  item.comment.replace(attachment.name,replaceString, 1);
                
                  item.comment =   item.comment.replace("[^","", 1);
                  item.comment =   item.comment.replace("</a>]","</a>", 1);

             
                
               
               // item.documents.splice(indx ,1);
                item.reslovedCommentAttachments =true;
                return  item.comment;
                
              
              }).catch(()=>{
                item.reslovedCommentAttachments =true;
                return comment;
              });
          
                    

            }else{
              item.reslovedCommentAttachments =true;
              return comment;
            }
            

          });
           
      }else{
        item.reslovedCommentAttachments =true;
        return comment;
      }

    },
     goTojira(key=''){
      window.open("https://deepvisioncs.atlassian.net/browse/"+key ,"_blank")

    },
    checkProperty(obj ,key='' ,subKye=''){
      
      if(_.has(obj , key)){
         //alert(key+" ---"+subKye)
        if(obj[key]){
          if(subKye==''){
            return obj[key];
          }else{

            if(_.has(obj[key] , subKye)){
              if(obj[key][subKye]){
                 return obj[key][subKye];
              }else{
                 return false;
              }

            }else{
              return false;
            }
          }
          
        }else{
          return false;
        }
     

      }else{
        return false;
      }

    }, 
    toggleEdit(item ,index , isitTogle =true){
       if(isitTogle){
         _.forEach(this.commentList ,(obj , ind)=>{

            if(index == ind){
              if(obj['edit']){
                obj['edit'] = false;
              }else{
                obj['edit'] = true;

                //this.selectedItem = item;
                this.selectedItem['commentId'] = item['_id'];
                this.selectedItem['comment'] = item['comment'];
                if(_.has(item ,"documents")){
                  this.selectedItem['documents'] = item['documents'];
                }else{
                  this.selectedItem['documents'] = [];

                }
                
                

              }
            }else{
              obj['edit'] = false;
            }


      });

       }else{

          this.selectedItem['commentId'] = item['_id'];
            this.selectedItem['comment'] = item['comment'];
            if(_.has(item ,"documents")){
              this.selectedItem['documents'] = item['documents'];
            }else{
              this.selectedItem['documents'] = [];

            }

       
      
       }
    },
    updateComment(approve =false){

      if(approve){
       this.selectedItem['intStatusId']  = 2; 
      }
      
     
      this.$vs.loading();
     
      this.$store
      .dispatch("jiracommentCommentCreate", this.selectedItem)
      .then((res) => {
        this.$vs.loading.close();
        this.getCommentList();
        this.initComment();
        this.$vs.notify({
          title: "Success",
          text: res.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "top-right",
          color: "success",
        });
        this.jiracommentActionPopup =false;
        this.jiraComment = {commentId:'',intStatusId:null,selectedintStatusId:null, comment:'', documents:[]};
      })
      .catch((error) => {
        this.$vs.loading.close();
        console.log(error)
        
        this.$vs.notify({
          title: "Error",
          text: error.message,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });

    },

    openJiracommentPopup(item){
      
      this.jiracommentActionPopup=true;
     this.jiraComment ={
      commentId:item['_id'],
      intStatusId:null,
      selectedintStatusId:null,
      comment:'',
      documents:[]
    };
    this.jiraComment.selectedintStatusId = _.find(this.jiraStatusList ,{"_id":item['intStatusId']});
    if(this.jiraComment.selectedintStatusId && _.has( this.jiraComment.selectedintStatusId , "_id")){

      this.jiraComment['intStatusId']  = this.jiraComment.selectedintStatusId["_id"];
    }
    

    this.documents = [];
    },
    download_file(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }
    /*
      value.url = value.url.replace(
        "https://lnaccounting.s3.ap-south-1.amazonaws.com/",
        ""
      );
      */
      // let postdata = { keyName: value.path , "taskId": this.taskDetails['_id']};
      let postdata = { keyName: value.url };

      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        
        window.open(response.data.result.data, "_blank");
        // window.location.href = response.data.result.data;
      });
    },
    getDetails() {
      
      const payload = {
          ticketId: this.ticketId,
      };
      this.$store
      .dispatch("getTicketDetails", payload)
      .then((res) => {
          this.ticketDetails = res;
          this.statusId = this.ticketDetails.statusDetails;
          this.currentStatusDetails  =   _.cloneDeep(this.ticketDetails.statusDetails);
          if (this.ticketDetails.assignEmpDetails && this.ticketDetails.assignEmpDetails.length > 0) {

             this.ticketDetails.assignEmpDetails.forEach(item => {
               if(_.has(item ,"roleName")){
                   item.name = item.name + '('+item.roleName +')'
               }
             
            })
            this.assignedTo = this.ticketDetails.assignEmpDetails[0];
          }
          this.getStatusList();
          
      })
      .catch((error) => {
        console.log(error)
      });
    },
    getCommentList() {
      let postData = {
        ticketId: this.ticketId,
        page: 1,
        perpage: 100,
      };
      this.commentList = [];
      this.$store
        .dispatch("getTicketCommentList", postData)
        .then((response) => {
         // this.commentList = response.list;

          let data  = response.list //.reverse();
          _.forEach(data ,(item)=>{
            item['edit'] =false;
            item["reslovedCommentAttachments"] =true;
            if(item.documents.length>0 || this.ticketDetails.documents.length>0){
                item["reslovedCommentAttachments"] =false;

            }
            
            this.commentList.push(item); 

          });


        })
        .catch((err) => {
          console.log(err);
        });
    },
    upload(model, title=''){
     
          let temp_count = 0;
                            
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  url:item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
              if (mapper.length > 0) {
                this.$vs.loading();
              mapper.forEach((doc, index) => {
                let formData = new FormData();  
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  this.$store.dispatch("uploadS3File", formData).then(response => {
                      temp_count++;
                      if(response.data.result.length>0){

                                       
                      response.data.result.forEach(urlGenerated => {
                          if(_.has(urlGenerated ,"path") && !( _.has(urlGenerated ,"url"))){
                              urlGenerated['url'] = urlGenerated ['path'];
                              
                          }
                           if(_.has(urlGenerated ,"url") && !( _.has(urlGenerated ,"path")) ){
                              urlGenerated['path'] = urlGenerated ['url'];
                              
                          }
                          
                          if(title == "jiraComment"){
                            this['jiraComment']['documents'].push(urlGenerated); 
                          }else if(title == 'selectedItem'){
                           
                            this.selectedItem['documents'].push(urlGenerated); 

                          } else{
                             this.comment.documents.push(urlGenerated);
                          } 
                           /*
                          if (title === 'comment') {
                            this.comment.documents.push(urlGenerated);       
                          } else if (title == 'ticket') {
                            this.ticketDetails.documents.push(urlGenerated)        
                          }
                          */
                                         
                               
                          if (temp_count >= mapper.length) {
                               
                             this.documents=[];
                              this.$vs.loading.close();
                          }

                          doc.url = urlGenerated;
                          delete doc.file;
                          mapper[index] = doc;

                      });
                  
                     }else{

                       this.documents=[];
                       this.$vs.loading.close();
                       this.$vs.notify({
                        title: "Error",
                        text: "Somting went wrong",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        position: "top-right",
                        color: "danger",
                      });

                     }
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }
    },
    remove(index, title){
      //selectedItem
      if (title == 'comment') { 
        this.comment.documents.splice(index ,1);
      } else if (title == 'ticket') {
        this.ticketDetails.documents.splice(index ,1);
      }else if (title == 'jiraComment') {
        this.jiraComment.documents.splice(index ,1);
      }else if (title == 'selectedItem') {
        this.selectedItem.documents.splice(index ,1);
      }

     
    },
    onSubmit() {
      const payload = this.comment;
      payload.statusId = this.ticketDetails.statusId;
      payload.ticketId = this.ticketId;
      this.$vs.loading();
     
      this.$store
      .dispatch("ticketCommentCreate", payload)
      .then((res) => {
        this.$vs.loading.close();
        this.getCommentList();
        this.initComment();
        this.$vs.notify({
          title: "Success",
          text: res.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "top-right",
          color: "success",
        });
      })
      .catch((error) => {
        this.$vs.loading.close();
        
        this.$vs.notify({
          title: "Error",
          text: error.message,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });
    },
    initComment() {
      this.comment = {
        comment: "",
        documents: [],
        today: moment().format("YYYY-MM-DD")
      }
    },    
    openUpdateStatus() {
      this.updateStatusFlag = true;
    },
     onUpdateStatus() {
      const payload = {
        ticketId: this.ticketId,
        statusId: this.statusId['_id'],
      };
      this.$vs.loading();
      this.$store
      .dispatch("updateTicketStatus", payload)
        .then((res) => {
          this.updateStatusFlag = false;
          this.$vs.loading.close();
          this.getDetails()
          this.$vs.notify({
            title: "Success",
            text: res.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    openUpdate() {
      this.ticketDetails.productId = this.ticketDetails.productDetails;
      this.ticketDetails.projectId = this.ticketDetails.projectDetails;
      this.popupUpdateticket = true;
    },
    onUpdate() {
      this.ticketDetails.productId = this.ticketDetails.productId._id;
       this.ticketDetails.projectId = this.ticketDetails.projectId._id;
       this.ticketDetails.ticketId = this.ticketId
      this.$vs.loading();
      this.$store
        .dispatch("supportTicketUpdate", this.ticketDetails)
        .then((res) => {
          this.popupUpdateticket = false;
          this.getDetails()
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
     openAssignPopup() {
      this.assignedTo = null; //[];
        if (this.ticketDetails.assignEmpDetails && this.ticketDetails.assignEmpDetails.length > 0) {
            this.assignedTo = this.ticketDetails.assignEmpDetails[0];
        } else {
          this.assignedTo = null;//[]
        } 
      this.popupAssignFlag = true;
    },
    addProject (newTag) {
      this.reportinglist.push( 
        { 'label':newTag, 'value':newTag} 
      )
    },
    onAssignEmployee() {
    //this.assignedTo = this.assignedTo.map(item => item._id);
     let selectedAssignedTo =[] 
      if( this.assignedTo != null && _.has(this.assignedTo ,"_id")){
       selectedAssignedTo =[ this.assignedTo['_id']] 
      }
     
    const payload = {
      ticketId: this.ticketId,
      assignedTo:selectedAssignedTo // this.assignedTo
    };
    this.$vs.loading();
    this.$store
      .dispatch("assignEmployees", payload)
      .then((res) => {
        this.popupAssignFlag = false;
        this.getDetails()
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Success",
          text: res.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "top-right",
          color: "success",
        });
      })
      .catch((error) => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: error.message,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });
    
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
     manageTicketStatuses(){

       //{'new':ticketDetails.statusId==1 , 'inprogress':ticketDetails.statusId==2 , 'closed':ticketDetails.statusId== 3 , 'rejected':ticketDetails.statusId==4, 'defered':ticketDetails.statusId==5,'resloved':ticketDetails.statusId==6,'reopen':ticketDetails.statusId==7}"
      if(this.activeUserInfo.roleId == 2){

        let statusList =  _.cloneDeep(this.status_list)
              this.status_list =  _.filter(statusList ,(obj)=>{
                  return obj._id ==3 || obj._id == 7
              });

       

      }else{

       if(this.ticketDetails && _.has(this.ticketDetails ,"statusId") && (this.ticketDetails.statusId ==3) ){
               let statusList =  _.cloneDeep(this.status_list)
               console.log(this.status_list);
              // this.status_list =  _.filter(statusList ,(obj)=>{
              //     return obj._id !=7
              // });
       }else{

         let statusList =  _.cloneDeep(this.status_list)
              this.status_list =  _.filter(statusList ,(obj)=>{
                  return obj._id !=7
              });

       }
     }

     },
     getStatusList(){
       this.$store.dispatch("getTicketStatus").then((response) => {
       this.status_list = response;
 
 /*_.filter(response ,(obj)=>{
         return obj._id !=1
       });

       _.forEach();
      if(this.userdata.roleId!=1){
        this.status_list =  _.filter(this.status_list ,(obj)=>{
         return obj._id !=3 && obj._id !=1
       });
      }
*/
      this.manageTicketStatuses();



 

    });

     }

  },
   mounted() {

    this.getStatusList();
     
     this.userdata = this.$store.state.auth.user;
     if (
      this.$route.params.id != undefined &&
      this.$route.params.id != null
    ) {
      this.ticketId = this.$route.params.id;
      this.getDetails();
    }
    
    this.$store.dispatch("getProducts").then((response) => {
      this.products = response;
    });
    this.$store.dispatch("getProjects").then((response) => {
      this.projects = response;
    });
    this.$store.dispatch("getEmployeeList").then((response) => {
      this.employeeList = response;
       this.employeeList.forEach(item => {
        item.name = item.name + '('+item.roleName +')'
      })
    });
    
     this.getCommentList();
     
  },
  watch:{
    jiracommentActionPopup:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    updateStatusFlag:function(val){
      // alert(JSON.stringify(this.statusId));
       let el = document.body;
      if (!val) {
         el.classList.remove('body-hidden');
        this.ticketDetails.statusId = this.currentStatusDetails['_id'];
        this.statusId = this.currentStatusDetails;
      }else{
        el.classList.add('body-hidden');
      }

    },
    popupUpdateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    popupAssignFlag:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    }
    
  }


}
</script>
<style  lang="scss">

.con-expand-users {
  .con-btns-user {
        display: flex;
        padding: 10px;
        padding-bottom: 0px;
        align-items: center;
        justify-content: space-between;
        .con-userx {
        display: flex;
        align-items: center;
        justify-content :flex-start;
            .list-icon {
                i{ font-size: .9rem !important;}
            }
        }
    }
}
.not-data-table  {display:none;}
 
.multiselect .multiselect__content-wrapper ul li .multiselect__option:after {    display: inline-block !important;
    content: attr(data-select);
    background: #41b883;    position: absolute;
    right: 5px;padding: 0 10px;
    color: #fff;}
</style>